export default {
    // 生产环境
    ssoBaseUrl : process.env.SSO_BASE_URL,
    ucenterApiBaseUrl : process.env.UCENTER_API_BASEURL,
    iotUrl: process.env.IOT_URL,


    appId : process.env.APP_ID,
    appSecret: process.env.APP_SECRET,
    tokenKey:  process.env.TOKEN_KEY,
    redirectKey:  process.env.REDIRECT_KEY,
    mqtt: {
        SSO_MQTT_SERVER:process.env.SSO_MQTT_SERVER,
        ssoOpeions: {
            username: "admin",
            password: "99ab8b7",
            clientId: 'sso_listen_' + Math.random().toString(16).substr(2, 8),
            cleanSession : false,
            keepAlive:60,
            connectTimeout: 4000,
            reconnectPeriod: 1000,                        //1000毫秒，两次重新连接之间的间隔
			connectTimeout: 5 * 1000,                     //1000毫秒，两次重新连接之间的间隔
			resubscribe: true,                            //如果连接断开并重新连接，则会再次自动订阅已订阅的主题（默认true）
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/config.js